module.exports = __webpack_public_path__ + "img/title_bg_green.97da6d3f.png";